export enum FeatureToggle {
  alcoholBasedOfferOption = 'rt_rfm_alcohol_based_offer_option',
  InsightsCampaignInsightsDisabledRetailers = 'rt_insights_campaign_insights_disabled_retailers',
  campaignsV2TemplateEmailEnabled = 'rt_campaigns_v2_template_email_enabled',
  campaignsV2TemplateGrowBasketSizes = 'rt_campaigns_v2_template_grow_basket_sizes',
  campaignsV2TemplateCrmOfflineEnabled = 'rt_campaigns_v2_template_crm_offline_enabled',
  campaignsV2TemplateCrmOfflineNonIncentiveEnabled = 'rt_campaigns_v2_template_crm_offline_non_incentive_enabled',
  campaignsV2TemplateLifecycleEnabled = 'rt_campaigns_v2_template_lifecycle_enabled',
  crmCampaignManualOverrides = 'rt_crm_campaign_manual_overrides',
  campaignV2TemplateMomentEnabled = 'rt_campaigns_v2_template_moment_enabled',
  retailerFundedMarketingUserDenyList = 'rt_rfm_user_deny_list',
  campaignsV2TemplateAcquisition = 'rt_campaigns_v2_template_acquisition',
  campaignsCrmPushEnabled = 'rt_campaigns_crm_push_enabled',
  campaignsDxGyEnabled = 'rt_campaigns_dxgy_integration',
  enableGlobalSegmentSelectionForRetailerSpecific = 'rt_enable_global_segment_selection_for_retailer_specific_campaigns',
  enableDefineCustomSegment = 'rt_enable_campaign_targeting_rule_builder',
  showMarketplaceCampaignsForCostco = 'rt_show_marketplace_campaigns_for_costco',
  rouletteModuleEnabled = 'rt_campaigns_roulette_module_enabled',
  showPredefinedSegmentsTargetingOption = 'rt_campaign_targeting_tooling_show_predefined_segments',
  ruleBuilderEnableUserEmailTargeting = 'rt_targeting_rule_builder_enable_user_email',
  ruleBuilderEnableLoyaltyTargeting = 'rt_targeting_rule_builder_enable_loyalty',
  ruleBuilderDisableLoyaltyTargeting = 'rt_targeting_rule_builder_disable_loyalty',
  ruleBuilderEnableInstacartRules = 'rt_targeting_rule_builder_enable_instacart_rules',
  useDynamicCsvUploadBucket = 'rt_use_dynamic_csv_upload_bucket',
  useDynamicCsvUploadBucketRetailer = 'rt_use_dynamic_csv_upload_bucket_retailer',
  ruleBuilderMultiConjunctionSegmentsEnabled = 'rt_rule_builder_multi_conjunction_segments_enabled',
  autoApplyBasketOffersEnabled = 'rt_auto_apply_basket_offers',
  retailerDepartmentOfferEnabled = 'rt_retailer_department_offer_enabled',
  searchAllSlotTypesEnabled = 'rt_search_all_slot_types_enabled',
  promoteStorefrontCreativesEnabled = 'rt_promote_storefront_creatives_enabled',
  autoApplyFeeDiscountEnabled = 'rt_auto_apply_fee_discount_enabled',
  termsAndConditionsOfferRedemptionLimitEnabled = 'rt_terms_and_conditions_offer_redemption_limit_enabled',
  checkoutBenefitCodeDiscountAsApplicationMethodEnabled = 'rt_checkout_benefit_code_discount_as_application_method_enabled',
  offerSetPriceWeightedItemEnabled = 'rt_offer_set_price_weighted_item_enabled',
  offerSetPriceUnitItemEnabled = 'rt_offer_set_price_unit_item_enabled',
  offerCouponApplyToMarketplaceEnabled = 'rt_offer_coupon_apply_to_marketplace_enabled',
  offerDiscountPerItemEnabled = 'rt_offer_discount_per_item_enabled',
  vgpFormV2OnSfxEnabled = 'rt_vgp_form_v2_on_sfx_enabled',
  vgpFormV2OnAdminEnabled = 'rt_vgp_form_v2_on_admin_enabled',
  vgpFormOverrideEnabled = 'rt_vgp_form_override_enabled',
  // Scalable Targeting Tooling rollout. Will be short lived
  useFeatureRegistryStoreGroups = 'rt_rule_builder_feature_registry_store_groups_enabled',
  useFeatureRegistryLoyaltyStatus = 'rt_rule_builder_feature_registry_loyalty_enabled',
  useFeatureRegstryEmailCSV = 'rt_rule_builder_feature_registry_email_csv_enabled',
  useFeatureRegistryRetailerOrders = 'rt_rule_builder_feature_registry_retailer_orders_enabled',
  useFeatureRegistryInstacartOrders = 'rt_rule_builder_feature_registry_instacart_orders_enabled',
  wholesalerCampaignsEnabled = 'rt_campaigns_wholesalers_enabled',
  retailerCustomCampaignEnabled = 'rt_retailer_custom_campaign_enabled',
  retailerScopeMultiSelectEnabled = 'rt_retailer_scope_multi_select_enabled',
  dsPropertiesEnabled = 'rt_campaigns_ds_properties_enabled',
  editableTemplateVariablesEnabled = 'rt_editable_template_variables_enabled',
  brandExclusionCriteriaInOffers = 'rt_brand_exclusion_criteria_in_offers',
  showAdminTemplatesPage = 'rt_campaigns_show_admin_templates_page',
  growthCampaignsIPPSlotSelection = 'rt_campaigns_ipp_slot_selection',
  growthCampaignsCustomUvcCreativesForIncentives = 'rt_campaigns_custom_uvc_creatives_for_incentives',
  targetingGenerativeAudienceEnabled = 'rt_targeting_generative_audience_enabled',
  wholesalerSegmentEnabled = 'rt_wholesaler_segment_enabled',
  lifecycleCrmEnabled = 'rt_lifecycle_crm_enabled',
  budgetCappingEnabled = 'rt_campaigns_ipp_budget_capping',
  retailerExclusionEnabled = 'rt_retailer_exclusion_enabled',
  tsDirectLinkEnabled = 'rt_ts_direct_link_enabled',
  offlineFeatureImprovement = 'rt_targeting_offline_feature_improvement',
  retailerAgnosticAdminProductControlsEnabled = 'rt_retailer_agnostic_admin_product_controls_enabled',
  bulkCouponCodesCreationEnabled = 'rt_bulk_coupon_codes_creation_enabled',
  customDiscountLabelsAtCheckoutEnabled = 'rt_custom_discount_labels_at_checkout_enabled',
  editCustomDiscountLabelsAtCheckoutEnabled = 'rt_edit_custom_discount_labels_at_checkout_enabled',
  emailPushOfflineFlowEnabled = 'rt_email_push_offline_flow_enabled',
  defaultOfflineCRMCampaignToPausedStatusEnabled = 'rt_default_offline_crm_campaign_to_paused_status_enabled',
  newToVerticalFeature = 'rt_new_to_vertical_feature',
  enableToolingForEurope = 'rt_campaign_tooling_enable_eu',
  itemLevelOfferStackabilityEnabled = 'rt_item_level_offer_stackability_enabled',
  flyoutSlotToolingEnabled = 'rt_flyout_slot_tooling_enabled',
  directLinkToolingEnabled = 'rt_direct_link_tooling_enabled',
}
